// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import {
  AppIcon,
  PageContainer,
  SectionContainer,
} from '@shared/ui-kit/components';
import { type FC } from 'react';
import { ProfileHeader } from './profile-header';
import { PersonalData } from './personal-data';
import { AdvisoryConditions } from './advisory-conditions';
import {
  useClientData,
  withClient,
} from '@shared/advisory/client-profile/providers';
import { Translation } from '@shared/ui-kit/providers';

const ProfileComponent: FC = () => {
  const { clientProfileQuery } = useClientData();

  return (
    <PageContainer
      className="[&_.page-container-actions-btn]:!relative [&_.page-container-actions-btn]:!flex [&_.page-container-actions-btn]:!gap-x-0"
      actionBtn={<ProfileHeader />}
      data-testid="profile"
      loading={clientProfileQuery.isLoading || clientProfileQuery.isFetching}
    >
      <div className="grid grid-cols-5 gap-6">
        <div className="col-span-5 space-y-6">
          <SectionContainer
            title={
              <span className="flex items-center space-x-3">
                <AppIcon icon="User" className="inline-block" size="xl" />
                <span>
                  <Translation
                    i18nKey="client-profile.personal-data.title"
                    ns="components"
                  />
                </span>
              </span>
            }
            testId="personal-data"
          >
            <PersonalData />
          </SectionContainer>

          <SectionContainer
            title={
              <span className="flex items-center space-x-3">
                <AppIcon icon="DollarSign" className="inline-block" size="xl" />
                <span>
                  <Translation
                    i18nKey="client-profile.advisory-conditions.title"
                    ns="components"
                  />
                </span>
              </span>
            }
            testId="advisory-conditions"
          >
            <AdvisoryConditions />
          </SectionContainer>
        </div>
      </div>
    </PageContainer>
  );
};

export const Profile = withClient(ProfileComponent);
